// Set version number and date in the environment.store.ts file

export const environment = {
  production: false,
  baseUrl: 'https://wholesaler-api-dev-emgya4b5f6dugjc6.westus2-01.azurewebsites.net',
  context: 'dev',
  maxEffectiveDateDays: 120,
};
